module.exports = __webpack_public_path__ + "static/media/Feb_2026_3.5ae3283e.webp";